import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './Store/Store';
import { BaseUrl } from "./JS/Common.js";
import { setConfig } from "./Store/Slices/configSlice";
import { log } from './JS/Logger.js';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

async function bootstrap() {
  try {
    // const currentOrigin = origin;
    // const domainsResponse = await fetch("/config/domains.json");
    // const domainsData = await domainsResponse.json();
    // const matchedDomain = domainsData.domains.find(d => d.url === currentOrigin);
    // const configFileName = matchedDomain ? matchedDomain.config : domainsData.default;

    const response = await fetch(`${BaseUrl}/basic/json/details`);
    if (!response.ok) throw new Error("Failed to fetch config");
    const configData = await response.json();
    store.dispatch(setConfig(configData?.data));

  } catch (err) {
    log.error("Config load failed:", err);
  }

  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  );
}

bootstrap();

reportWebVitals();